import script from "./leftnav.vue?vue&type=script&setup=true&lang=js"
export * from "./leftnav.vue?vue&type=script&setup=true&lang=js"

import "./leftnav.vue?vue&type=style&index=0&id=c87b0320&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c87b0320"]])

export default __exports__